import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

var TooltipComponent = function TooltipComponent(_ref) {
  var id = _ref.id,
      text = _ref.text,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'left' : _ref$position,
      children = _ref.children,
      className = _ref.className,
      trigger = _ref.trigger;
  return text ? React.createElement(OverlayTrigger, {
    rootClose: true,
    trigger: trigger,
    placement: position,
    overlay: React.createElement(Tooltip, {
      id: id
    }, text)
  }, React.createElement('span', {
    className: className
  }, children)) : React.createElement(React.Fragment, null, children);
};

TooltipComponent.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  children: PropTypes.node,
  className: PropTypes.string,
  trigger: PropTypes.array
};
TooltipComponent.defaultProps = {
  position: 'left',
  trigger: ['hover', 'focus']
};
export default TooltipComponent;